<div class="space-for-scroll bg-neutral-0 flex h-full flex-col">
  <div class="flex flex-1 flex-col justify-center py-4">
    <div class="small:w-[360px] small:mx-auto flex h-full min-h-0 flex-col justify-center">
      <div class="flex flex-col">
        <h2 class="text-display-md small:mb-8 mb-5 text-center font-medium text-neutral-950">
          Sign in to your account
        </h2>
        <dojo-button [fill]="'outline'" (click)="loginWithGoogleProvider()">
          <ion-img class="h-5 w-5" src="./assets/images/google-logo.png" />
          <span class="ml-3">{{ 'examdojo.registration.sign_in_with' | transloco: { provider: 'Google' } }}</span>
        </dojo-button>
        <dojo-button [fill]="'outline'" class="mt-3" (click)="loginWithDiscordProvider()">
          <ion-img class="h-5 w-5" src="./assets/images/discord-logo.svg" />
          <span class="ml-3">{{ 'examdojo.registration.sign_in_with' | transloco: { provider: 'Discord' } }}</span>
        </dojo-button>
        <span
          class="small:my-6 relative my-3 text-center font-semibold uppercase text-neutral-400 after:absolute after:left-0 after:top-[50%] after:h-px after:w-full after:bg-neutral-200 after:content-['']"
        >
          <span class="z-1 bg-neutral-0 relative px-2">or sign up with email</span>
        </span>
        <form [formGroup]="form" class="flex w-full flex-col">
          <y42-text-input
            label="Email"
            type="email"
            [formCtrl]="form.controls.email"
            data-test="sign-in-input-email"
            autocomplete="email"
            [errorMessages]="emailErrorMessages"
            [hasInitialFocus]="isDesktop"
          />

          <y42-password-input
            class="mb-6 mt-4"
            label="Password"
            [formCtrl]="form.controls.password"
            data-test="sign-in-input-password"
            autocomplete="current-password"
            [errorMessages]="{
              required: 'Password is required'
            }"
          />
          <dojo-button submitButton [confirmFn]="confirmFn" [attr.data-test]="'register-button-create-account'">
            Sign in
          </dojo-button>

          @if (error) {
            <mat-error class="mt-2 text-center">
              {{ error }}
            </mat-error>

            <div class="mt-3 text-center">
              <a class="dashed-link" (click)="sendPasswordResetLink()" data-test="forgot-password-button"
                >Forgot password?</a
              >
            </div>
          }
        </form>
        <div
          class="mt-6 text-center text-xs font-normal text-neutral-700"
          [innerHTML]="
            'examdojo.registration.sign_up_terms_and_conditions'
              | transloco
                : {
                    tac_url: 'https://examdojo.com/legal/terms-and-conditions',
                    privacy_policy_url: 'https://examdojo.com/legal/privacy-policy'
                  }
          "
        ></div>
        <div class="mt-4 flex items-center justify-center gap-4 text-center text-sm font-normal">
          <span class="text-neutral-700">{{ 'examdojo.registration.new_user_question' | transloco }}</span>
          <a
            [routerLink]="registerUrl"
            class="ml-1 flex items-center gap-1 font-medium text-sky-600 hover:text-sky-800"
          >
            <span>{{ 'examdojo.registration.sign_up' | transloco }}</span>
            <dojo-icon [icon]="'arrow-right'"></dojo-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
